<template>
  <div :class="['network-graph', attributes.value.key.toLowerCase().replace(/ /gi, '-')]">
    <div class="caption" v-markdown="caption"></div>
    <graphsingle :dataset="dataset" :alldata="jsonkeydata"/>
  </div>
</template>

<script>
import graphsingle from './graph-single.vue'
import {debounce, find} from 'lodash'
import _countBy from 'lodash/countBy'
import {mapState} from 'vuex'

export default {
  props: ['attributes'],
  computed: mapState(['jsonkeydata', 'variabledata']),
  components: {
    graphsingle
  },
  data () {
    return {
      dataset: {},
      caption: ''
    }
  },
  watch: {
    'variabledata': function (newVal, oldVal) {
      this.setGraphData()
    }
  },
  methods: {
    generateCaption () {
      if (!this.attributes.value.caption) return
      const captArr = this.attributes.value.caption.split(';')
      const reg = /\{\{(.*?)\}\}/
      var htmlstr = ''
      var found = false
      var varVal = ''
      captArr.forEach((element, i) => {
        found = reg.exec(element)
        if (found) {
          const key = found[1].replace('word', '')
          if (key === 'numcases') {
            varVal = found[1].includes('word') ? this.$numToWord(this.dataset.totals[0]) : this.dataset.totals[0]
          } else if (key === 'numrecovered') {
            const counts = _countBy(this.dataset.info[0], (item) => {
              return item.condition
            })
            varVal = counts ? counts.recovered || 0 : 0
            varVal = found[1].includes('word') ? this.$numToWord(varVal) : varVal
          } else if (key === 'numdied') {
            const counts = _countBy(this.dataset.info[0], (item) => {
              return item.condition
            })
            varVal = counts ? counts.died || 0 : 0
            varVal = found[1].includes('word') ? this.$numToWord(varVal) : varVal
          }
          htmlstr += `<span class="${found[1]}">${element.replace(found[0], varVal)}</span>`
        }
      })
      this.caption = htmlstr
    },
    setGraphData () {
      const dataset = {
        labels: [],
        totals: [],
        info: [],
        name: 'clusters',
        showinfo: true,
        key: this.attributes.value.key,
        externalconnection: null
      }
      if (this.variabledata.clusters[this.attributes.value.key]) {
        dataset.labels.push('')
        dataset.totals.push(this.variabledata.clusters[this.attributes.value.key].length)
        dataset.info.push(this.variabledata.clusters[this.attributes.value.key])
        dataset.externalconnection = find(this.variabledata.clusters[this.attributes.value.key], (item) => {
          return item['case-connections-outside-cluster']
        })
      } else if (this.attributes.value.key === 'nocluster') {
        dataset.labels.push('')
        dataset.totals.push(this.variabledata.nocluster.length)
        dataset.info.push(this.variabledata.nocluster)
      } else if (this.attributes.value.key === 'noorigin') {
        dataset.labels.push('')
        dataset.totals.push(this.variabledata.noorigin.length)
        dataset.info.push(this.variabledata.noorigin)
      }
      this.dataset = dataset

      this.generateCaption()
    }
  },
  mounted () {
    // const self = this
    window.addEventListener('resize', debounce(function () {
      // self.triggerOffset = document.documentElement.clientHeight + document.querySelector('.content-box').offsetHeight
    }, 100))
  }
}
</script>

<style lang="scss" scoped>
.network-graph {
  min-height: 500px;
  .caption {
    &:first-letter {
      text-transform: uppercase;
    }
  }
}

</style>
